import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const responseSchema = yup.object({
  isEnabled: yup.boolean().required(),
  shopDomain: yup.string().nullable(),
  syncProducts: yup.boolean().required(),
  updatedAt: yup.string().nullable(),
});

const composeResponse = (res) => {
  const data = res?.data?.data || {};
  return {
    isEnabled: !!data.is_enabled && !!data.admin_api_access_token,
    shopDomain: data.shop_domain,
    syncProducts: !!data.sync_products,
    updatedAt: data.updated_at || null,
  };
};

export const useShopifyAuthDataQuery = (options = {}) => {
  return useQuery(
    [QUERY_KEYS.shopifyAuthData],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getShopifyAuthData());
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    options,
  );
};
